import { createFileRoute, redirect } from '@tanstack/react-router';

import { getisRegistered } from 'hooks/useIsRegistered';
import { preloadSourceApps } from 'hooks/useQuery/useQuerySourceApps';

import { DirectoryView } from 'views/DirectoryView/DirectoryView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/directory/$id')({
  beforeLoad: async ({ context, params }) => {
    const apps = await preloadSourceApps(context.queryClient, params.id);

    const [app] = apps || [];

    if (app.directory === false || app.directoryUrl === null) {
      throw redirect({ to: '/info/$id/', params: { id: params.id } });
    }
    const isRegistered = await getisRegistered(context.queryClient, params.id);

    if (isRegistered) {
      context.hideButtonBarButtons = ['info', 'training'];
    } else {
      context.hideButtonBarButtons = ['search'];
    }

    return context;
  },
  component: DirectoryView,
  staticData: {
    disableLayoutMaxWidth: true,
    disablePointBar: true,
  },
});
